<template>
	<countdown v-if="compactCountdown" class="countdown-timer compact" :time="timeRemaining" @end="countdownend">
		<template slot-scope="props">
			<span class="time-number _days">{{ props.days }}<span class="time-prefix">d&nbsp;</span></span>
			<span class="time-number _hours">{{ props.hours }}<span class="time-prefix">h&nbsp;</span></span>
			<span class="time-number _minutes">{{ props.minutes }}<span class="time-prefix">m&nbsp;</span></span>
			<span class="time-number _seconds">{{ props.seconds }}<span class="time-prefix">s</span></span>
		</template>
	</countdown>
	<countdown
		v-else
		class="countdown-timer big"
		:time="timeRemaining"
		:style="{ lineHeight: lineHeight }"
		@end="countdownend"
	>
		<template slot-scope="props">
			<span>
				<span class="style-counter-label">DAGAR</span>
				<span class="style-counter">{{ props.days }}</span>
			</span>
			<span class="style-separator style-counter">
				:
			</span>
			<span>
				<span class="style-counter-label">TIMMAR</span>
				<span class="style-counter">{{ props.hours }}</span>
			</span>
			<span class="style-separator style-counter">
				:
			</span>
			<span>
				<span class="style-counter-label">MINUTER</span>
				<span class="style-counter">{{ props.minutes }}</span>
			</span>
			<span class="style-separator style-counter">
				:
			</span>
			<span>
				<span class="style-counter-label">SEKUNDER</span>
				<span class="style-counter">{{ props.seconds }}</span>
			</span>
		</template>
	</countdown>
</template>
<script>

export default {
	props: {
		targetTime: {
			type: Date,
			required: null,
		},
		lineHeight: {
			type: String,
			default: '1.6',
		},
		compactCountdown: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			timeRemaining: 0,
		};
	},
	mounted () {
		this.init();
	},
	methods: {
		init () {
			this.timeRemaining = 0;
			if (this.targetTime) {
				const now = new Date();
				this.timeRemaining = Math.max(this.targetTime - now, 0);
			}
		},
		countdownend () {
			if (this.timeRemaining > 0) {
				this.$emit('countdownEnded', true);
			}
		},
	},
	watch: {
		targetTime () {
			this.init();
		},
	},
};
</script>
